import React from 'react'
import styled from 'styled-components'

const StyledSectionHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  margin-left: -10px;
  margin-right: -10px;

  .section-title,
  .col-header {
    padding-left: 10px;
    padding-right: 10px;
  }

  .section-title {
    flex-grow: 1;
    flex-basis: 0;
    display: flex;
    align-items: center;
    font-size: 22px;
  }

  .edit-link {
    font-size: 14px;
    cursor: pointer;
    opacity: 0.6;
    text-decoration: underline;
    margin-left: 10px;
    font-weight: normal;
  }

  .col-header {
    width: 195px;
    text-align: right;
  }
`

export const BBCSectionHeader = ({ title, colHeaders, showEditLink = false, onEditClick = null, showLast }) => (
  <StyledSectionHeader>
    <h3 className="section-title" data-testid={'bbc-section-title'}>
      {title}
      {showEditLink && (
        <span className="edit-link" onClick={onEditClick}>
          Edit
        </span>
      )}
    </h3>
    {colHeaders.map((colHeader, i) => {
      if (!showLast && colHeader.indexOf('Last') === 0) {
        return null
      }
      return (
        <span className="col-header" key={i}>
          {colHeader}
        </span>
      )
    })}
  </StyledSectionHeader>
)
